import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product_detail_image_area"
}
const _hoisted_2 = { class: "thum_img_bx" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.product.hasDetailImage)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _ctx.product.productDetailImageUrl,
            class: "thum_img",
            alt: ""
          }, null, 8, ["src"])
        ])
      ]))
    : _createCommentVNode("", true)
}